import { ChangeDetectionStrategy, Component, inject, viewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { browserHelpers } from '@core';

import { BtService } from '../../services/bt';
import { WifiPickerComponent } from './wifi-picker.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    MatDialogModule,
    WifiPickerComponent,
    MatIcon,
  ],
  providers: [BtService],
  templateUrl: './wifi-picker-dialog.component.html',
})
export class WifiPickerDialogComponent {
  protected browserHelpers = browserHelpers;
  protected data = inject<{ deviceId: string; }>(MAT_DIALOG_DATA, { optional: true });
  protected wifiPicker = viewChild.required(WifiPickerComponent);

  private dialogRef = inject(MatDialogRef, { optional: true });

  protected async connect() {
    const succeeded = await this.wifiPicker().connect();

    if (succeeded) {
      this.dialogRef?.close();
    }
  }
}
